export const build = {
  'version': '1.3.0',
  'stamp': '08-11-2020',
};
